export default "__VITE_ASSET__Pa6Ch4z1__"